import React from 'react'

const SORT_ITEMS = [
  { value: 'name-asc', name: 'Alfabéticamente (A-Z)' },
  { value: 'name-desc', name: 'Alfabéticamente (Z-A)' },
  { value: 'createdAt-asc', name: 'Fecha de creación (Antiguo a Nuevo)' },
  { value: 'createdAt-desc', name: 'Fecha de creación (Nuevo a Antiguo)' },
]

const DropdownSearch = ({ sortValue = { name: 1 }, onChangeSort }) => {
  const handleSort = sort => {
    const [field, value] = sort.split('-')
    if (field && value) {
      onChangeSort({ [field]: value === 'asc' ? 1 : -1 })
    }
  }
  
  const getSortValue = () => {
    const field = Object.keys(sortValue)[0]
    const order = sortValue[field] === 1 ? 'asc' : 'desc'
    return `${field}-${order}`
  }
    
  return (
    <div className="dropdown-search">
      <select
        id="options"
        className="dropdown-search__select"
        value={getSortValue()}
        onChange={e => handleSort(e.target.value)}
      >
        {SORT_ITEMS.map((item, index) => (
          <option key={index} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default DropdownSearch
